function hasElements<T>(array: T[] | ArrayLike<T> | TimeRanges): array is [T, ...T[]] {
    return array.length > 0;
}

export {hasElements};
